enum RootPath {
    QUESTIONNAIRE_PREVIEW = 'dqp',
    SCHEDULE_REPORT_FOLIO_LIST = 'dcrf',
    USER_SCHEDULE_REPORT_FOLIO_LIST = 'ducrf',
    QUESTIONNAIRE_EDIT = 'dqe',
    QUESTIONNAIRE_PERMISSION = 'dqpe',
    SCHEDULE_DETAIL_LIST = 'dcdl',
    RECURRENCE = 'dcr',
    RECURRENCE_USER = 'ducr',
    SCHEDULE_DETAIL = 'dcdld',
    USER_SCHEDULE_DETAIL_LIST = 'ducdl',
    USER_SCHEDULE_DETAIL = 'ducdld',
    SCHEDULE = 'dcd',
    USER_SCHEDULE = 'ducd',
}

enum BreadCrumLabels {
    Edit_Questionnaire = 'eq',
    PREVIEW_QUESTIONNAIRE = 'pq',
    PERMISSIO_QUESTIONNAIRE = 'peq',
    SCHEDULE_DETAIL_LIST = 'dcdl',
    SCHEDULE_DETAIL = 'dcdld',
    USER_SCHEDULE_DETAIL_LIST = 'ducdl',
    SCHEDULE = 'dcd',
    USER_SCHEDULE = 'ducd',
    RECURRENCE = 'dcr',
    RECURRENCE_USER = 'ducr',
    USER_SCHEDULE_DETAIL = 'ducdld',
    SCHEDULE_REPORT_FOLIO_LIST = 'dcrf',
    USER_SCHEDULE_REPORT_FOLIO_LIST = 'ducrf',
}

enum BreadCrumEquivalence {
    DETAIL_SCHEDULEDETAIL = 'detailEdit>scheduleDetail'
}
enum BreadcrumbTypes {
    EDIT = '1',
    BLOCK_All_ACTIONS = '2'
}

enum BreadCrumbKeys {
    ROOT = 'root',
    LABEL = 'label',
    EQUIVALENCE = 'equivalence',
    ACTIONS = 'actions',
    KEY = 'key'
}
export { RootPath, BreadcrumbTypes, BreadCrumLabels, BreadCrumbKeys, BreadCrumEquivalence }